/**
 * Whether ticket printing is on for this terminal (FR-226, FR-227).
 *
 * A SEPARATE FILE FROM `index.ts` ON PURPOSE. Both the settings screen and the
 * module composition root need this flag, and `index.ts` already imports the
 * settings screen for its `till.settings` slot — putting the flag there too
 * would make the settings screen import back from `index.ts`, a circular
 * import between the composition root and the component it composes.
 *
 * Independent of the drawer's own enable state: turning tickets off must not
 * touch drawer behaviour, which is a separate control with its own rules.
 */

let enabled = true;

export function isTicketPrintingEnabled(): boolean {
  return enabled;
}

export function setTicketPrintingEnabled(next: boolean): void {
  enabled = next;
}
